import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Timeline as MuiTimeline, TimelineConnector as MuiTimelineConnector, TimelineContent as MuiTimelineContent, TimelineItem as MuiTimelineItem, TimelineOppositeContent as MuiTimelineOppositeContent, TimelineSeparator as MuiTimelineSeparator, } from '@mui/lab';
import { Typography, } from '../../atoms';
import { useIsMobile } from '../../hooks';
import { styled } from '../../legacy/utils';
import { MobileTimelineItem } from './MobileTimelineItem';
import { TimelineDot } from './TimelineDot';
export function Timeline({ timelineItems, noItemsText, noItemsTextVariant = 'body2 light', noItemsTextColor = 'darkBlue', }) {
    const isMobile = useIsMobile();
    return (_jsx(_Fragment, { children: timelineItems && timelineItems.length > 0 ? (_jsx(TimelineStyled, { children: timelineItems &&
                timelineItems.map((timelineItem, index) => (_jsx("div", { children: isMobile ? (_jsx(MobileTimelineItem, { timelineConnector: index !== timelineItems.length - 1, date: timelineItem.date, time: timelineItem.time, header: timelineItem.header, body: timelineItem.body, iconVariant: timelineItem.iconVariant, iconColor: timelineItem.iconColor, children: timelineItem.children })) : (_jsxs(MuiTimelineItem, { children: [_jsx(MuiTimelineOppositeContent, { children: _jsxs(_Fragment, { children: [_jsx(Typography, { variant: "body2 light", children: timelineItem.date }), _jsx(Typography, { variant: "body2 light", children: timelineItem.time })] }) }), _jsxs(MuiTimelineSeparator, { children: [_jsx(TimelineDot, { iconVariant: timelineItem.iconVariant, iconColor: timelineItem.iconColor }), index !== timelineItems.length - 1 && (_jsx(MuiTimelineConnector, {}))] }), _jsx(MuiTimelineContent, { children: _jsxs(_Fragment, { children: [_jsx(Typography, { variant: "body1 semibold", color: "darkBlue", children: timelineItem.header }), _jsx(Typography, { variant: "body2 light", children: timelineItem.body }), timelineItem.children] }) })] })) }, index))) })) : (_jsx(Typography, { variant: noItemsTextVariant, color: noItemsTextColor, children: noItemsText ?? '' })) }));
}
const TimelineStyled = styled(MuiTimeline)(({ theme }) => ({
    color: theme.palette.primary.main,
    '&.MuiTimeline-root': {
        margin: '0',
        padding: '0',
    },
    '& .MuiTimelineOppositeContent-root': {
        paddingLeft: '0',
    },
    '& .MuiTimelineOppositeContent-positionRight:first-of-type': {
        marginLeft: '0',
        paddingLeft: '0',
    },
    '& .MuiTimelineOppositeContent-positionRight :first-of-type': {
        minWidth: '76px',
        flex: '1 0',
        whiteSpace: 'nowrap',
        overflowX: 'auto',
    },
    '& .MuiTimelineItem-root :nth-of-type(3)': {
        flex: '100',
        backgroundColor: 'transparent',
    },
    '& .MuiTimelineItem-root:before': {
        padding: '0',
        flex: '0',
    },
    '& .MuiTimelineConnector-root': {
        width: '1px',
        backgroundColor: theme.palette.divider,
    },
}));
